export class UpdateCompanyResult {
    public result: boolean = false;
    public id?: number;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }
}
